import React from 'react';
import {createRoot} from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import {Provider} from 'react-redux';
import '@babel/polyfill';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import './common/utils/propTypesCompat';
import configureStore from './app/configurestore';
import initialState from './app/initialstate';
import Routes from './app/Routes';
import './common/utils/svg';
import config from './auth/config';
import {Providers, SimpleProvider, ProviderState} from '@microsoft/mgt';
import {MsalService} from '@ey/voltron-core';
import {checkUserAcceptedPaansPolicy} from '@features/paans/paans';
import {getErrorMessage, getErrorMessageFromResponse} from '@util/utils';

document.addEventListener('DOMContentLoaded', () => {
	const store = configureStore(initialState);

	store.dispatch({type: 'HOME_LOGIN', isOnline: true}).then(async () => {
		const isAdmin = window.location.pathname === '/admin' ? true : false;
		store
			.dispatch(checkUserAcceptedPaansPolicy(isAdmin, window.location.href))
			.then(() => {
				const userHasAcceptedPolicy = store.getState().paansuserdata;
				const hasaccepted = userHasAcceptedPolicy.hasAccepted;
				const redirectUrl = userHasAcceptedPolicy.redirectUrl;
				if (hasaccepted !== undefined && redirectUrl !== undefined) {
					if (hasaccepted === false) {
						window.location.href = redirectUrl;
					}
				}
			})
			.catch((paansError) => {
				const errorMessage = getErrorMessageFromResponse(getErrorMessage(paansError));
				console.log('Error in PAANS: ', errorMessage);
			});

		const authService = new MsalService(config);
		const account = await authService.getActiveAccountAsync();
		if (account) {
			const graphScopes = [
				'user.read',
				'user.read.all',
				'Presence.Read',
				'Presence.Read.All',
				'people.read',
				'contacts.read',
				'sites.read.all',
				'Mail.ReadBasic',
				'people.read.all'
			];

			Providers.globalProvider = new SimpleProvider(async (scopes) => {
				const tokenRequest = {
					scopes: scopes || graphScopes,
					account: account
				};
				const response = await authService.app.acquireTokenSilent(tokenRequest);
				return response.accessToken;
			});
			Providers.globalProvider.setState(ProviderState.SignedIn);
		}

		const root = createRoot(document.getElementById('mount'));
		root.render(
			<Provider store={store}>
				<BrowserRouter>
					<Routes />
				</BrowserRouter>
			</Provider>
		);
	});
});
